import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';
import { BehaviorSubject, Observable, Subject, take, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { AgencyService } from 'src/app/services/agency.service';

@Component({
  selector: 'ness-sl-agency-filter',
  templateUrl: './sl-agency-filter.component.html'
})
export class SlAgencyFilterComponent implements OnInit {
  @Input() userAgencies: ServerModels.AgencyViewModel[] = [];
  @Output() selectedAgencies = new EventEmitter<string | MultiSelectChangeEvent>();
  @ViewChild('agencyms') agencyMultiSelect: MultiSelect;
  public agenciesSubj: BehaviorSubject<ServerModels.AgencyViewModel[]> = new BehaviorSubject<ServerModels.AgencyViewModel[]>([]);
  public agencies$: Observable<ServerModels.AgencyViewModel[]> = this.agenciesSubj.asObservable();
  private _unsubscribe$: Subject<void> = new Subject<void>();
  private _agencies: ServerModels.AgencyViewModel[] = [];

  get sAgencies(): ServerModels.AgencyViewModel[] {
    return this._agencies;
  }

  set sAgencies(agency: ServerModels.AgencyViewModel[]) {
    this._agencies = agency;
  }

  constructor(public agencyService: AgencyService,
    private authService: AuthService,
    public elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    if (!this.authService.hasRole(['NESS Administrator']) && this.authService.hasUserType(['StateLocalLE'])) {
      if (this.userAgencies) {
        this.agenciesSubj.next(this.userAgencies);
      }
      else {
        this.agencyService.GetAgenciesForCurrentStateAndLocalUser().pipe(take(1)).subscribe((ag: ServerModels.AgencyViewModel[]) => {
          this.agenciesSubj.next(<ServerModels.AgencyViewModel[]>ag);
        });
      }
    }
  }

  public onSelectAgencies(evt: MultiSelectChangeEvent): void {
    this.agencies$.pipe(takeUntil(this._unsubscribe$)).subscribe((arr: ServerModels.AgencyViewModel[]) => {
      if (evt.value.length != arr.length) {
        this.selectedAgencies.emit(evt);
      }
      else {
        this.selectedAgencies.emit('All');
      }
    });    
  }

  public clearSelections(): void {
    this._agencies = [];
    this.agencyMultiSelect.cd.detectChanges();
  }
}
